import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_MEDIA_GATEWAY = '/mediagateway';

export const SET_MEDIA_GATEWAY_LOADING = 'SET_MEDIA_GATEWAY_LOADING';
export const GO_TO_MEDIA_GATEWAY_CREATE = 'GO_TO_MEDIA_GATEWAY_CREATE';
export const GO_TO_MEDIA_GATEWAY_EDIT = 'GO_TO_MEDIA_GATEWAY_EDIT';
export const GO_TO_MEDIA_GATEWAY_VIEW = 'GO_TO_MEDIA_GATEWAY_VIEW';
export const GO_TO_MEDIA_GATEWAY_COPY = 'GO_TO_MEDIA_GATEWAY_COPY';
export const GO_TO_MEDIA_GATEWAY_LIST = 'GO_TO_MEDIA_GATEWAY_LIST';
export const GET_MEDIA_GATEWAY_LIST = 'GET_MEDIA_GATEWAY_LIST';
export const GET_MEDIA_GATEWAY_LIST_PENDING = 'GET_MEDIA_GATEWAY_LIST_PENDING';
export const GET_MEDIA_GATEWAY_LIST_FULFILLED = 'GET_MEDIA_GATEWAY_LIST_FULFILLED';
export const GET_MEDIA_GATEWAY = 'GET_MEDIA_GATEWAY';
export const GET_MEDIA_GATEWAY_PENDING = 'GET_MEDIA_GATEWAY_PENDING';
export const GET_MEDIA_GATEWAY_FULFILLED = 'GET_MEDIA_GATEWAY_FULFILLED';
export const CREATE_MEDIA_GATEWAY = 'CREATE_MEDIA_GATEWAY';
export const CREATE_MEDIA_GATEWAY_PENDING = 'CREATE_MEDIA_GATEWAY_PENDING';
export const CREATE_MEDIA_GATEWAY_FULFILLED = 'CREATE_MEDIA_GATEWAY_FULFILLED';
export const CREATE_MEDIA_GATEWAY_REJECTED = 'CREATE_MEDIA_GATEWAY_REJECTED';
export const UPDATE_MEDIA_GATEWAY = 'UPDATE_MEDIA_GATEWAY';
export const UPDATE_MEDIA_GATEWAY_FULFILLED = 'UPDATE_MEDIA_GATEWAY_FULFILLED';
export const UPDATE_MEDIA_GATEWAY_REJECTED = 'UPDATE_MEDIA_GATEWAY_REJECTED';
export const DELETE_MEDIA_GATEWAY = 'DELETE_MEDIA_GATEWAY';
export const DELETE_MEDIA_GATEWAY_FULFILLED = 'DELETE_MEDIA_GATEWAY_FULFILLED';
export const DELETE_MEDIA_GATEWAY_REJECTED = 'DELETE_MEDIA_GATEWAY_REJECTED';
export const SELECT_MEDIA_GATEWAY = 'SELECT_MEDIA_GATEWAY';

export enum MediaGatewayPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export enum MediaGatewayMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export interface MediaGateway {
  mgwtype: string,
  id: number
  ipaddr: string
  port: number
  name: string
  reqstate: string
  version: string
  ownnetid: string
  enablejitter: string
  mgwuri: string
  insidenat: string
  mediagatewaynumlist: MediaGatewayNumList[]
}

export interface AdaptedMediaGateway {
  mgwtype: string,
  id: number
  ipaddr: string
  port: number
  name: string
  reqstate: string
  version: string
  ownnetid: string
  enablejitter: string
  mgwuri: string
  insidenat: string
  mediagatewaynumlist: string[]
}

export interface MediaGatewayNumList {
  id: number
  cid: number
  callingnum: string
}

export interface MediaGatewayState {
  entities: MediaGateway[]
  selected: MediaGateway[],
  single: MediaGateway | null
  createdId: string | null
  ui: MediaGatewaysUIState
}

export interface MediaGatewaysUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToMediaGatewayListAction extends AnyAction {
  type: typeof GO_TO_MEDIA_GATEWAY_LIST
}

export interface SetMediaGatewayLoadingAction extends AnyAction {
  type: typeof SET_MEDIA_GATEWAY_LOADING
  payload: { isLoading: boolean }
}

export interface GetMediaGatewayListAction extends AnyAction {
  type: typeof GET_MEDIA_GATEWAY_LIST
  payload: AxiosPromise<ServerResponse<MediaGateway>>
}

export interface GetMediaGatewayListPendingAction extends AnyAction {
  type: typeof GET_MEDIA_GATEWAY_LIST_PENDING
  payload: null
}

export interface GetMediaGatewayListFulfilledAction extends AnyAction {
  type: typeof GET_MEDIA_GATEWAY_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<MediaGateway>>
}

export interface GetMediaGatewayAction extends AnyAction {
  type: typeof GET_MEDIA_GATEWAY
  payload: AxiosPromise<ServerResponse<MediaGateway>>
}

export interface GetMediaGatewayPendingAction extends AnyAction {
  type: typeof GET_MEDIA_GATEWAY_PENDING
  payload: null
}

export interface GetMediaGatewayFulfilledAction extends AnyAction {
  type: typeof GET_MEDIA_GATEWAY_FULFILLED
  payload: AxiosResponse<ServerResponse<MediaGateway>>
}

export interface CreateMediaGatewayThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface CreateMediaGatewayAction extends AnyAction {
  type: typeof CREATE_MEDIA_GATEWAY
  payload: AxiosPromise<ServerResponse<MediaGateway>>
}

export interface CreateMediaGatewayPendingAction extends AnyAction {
  type: typeof CREATE_MEDIA_GATEWAY_PENDING
  payload: null
}

export interface CreateMediaGatewayFulfilledAction extends AnyAction {
  type: typeof CREATE_MEDIA_GATEWAY_FULFILLED
  payload: AxiosResponse<ServerResponse<MediaGateway>>
}

export interface CreateMediaGatewayRejectedAction extends AnyAction {
  type: typeof CREATE_MEDIA_GATEWAY_REJECTED
  payload: AxiosResponse<ServerResponse<MediaGateway>>
}

export interface UpdateMediaGatewayThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateMediaGatewayAction extends AnyAction {
  type: typeof UPDATE_MEDIA_GATEWAY
  payload: AxiosPromise<ServerResponse<MediaGateway>>
}

export interface UpdateMediaGatewayFulfilledAction extends AnyAction {
  type: typeof UPDATE_MEDIA_GATEWAY_FULFILLED
  payload: AxiosResponse<ServerResponse<MediaGateway>>
}

export interface UpdateMediaGatewayRejectedAction extends AnyAction {
  type: typeof UPDATE_MEDIA_GATEWAY_REJECTED
  payload: AxiosResponse<ServerResponse<MediaGateway>>
}

export interface DeleteMediaGatewayThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface DeleteMediaGatewayAction extends AnyAction {
  type: typeof DELETE_MEDIA_GATEWAY
  payload: AxiosPromise<ServerResponse<MediaGateway>>
}

export interface DeleteMediaGatewayFulfilledAction extends AnyAction {
  type: typeof DELETE_MEDIA_GATEWAY_FULFILLED
  payload: AxiosResponse<ServerResponse<MediaGateway>>
}

export interface DeleteMediaGatewayRejectedAction extends AnyAction {
  type: typeof DELETE_MEDIA_GATEWAY_REJECTED
  payload: AxiosResponse<ServerResponse<MediaGateway>>
}

export interface SelectMediaGatewayAction extends AnyAction{
  type: typeof SELECT_MEDIA_GATEWAY
  payload: MediaGateway[]
}

export type MediaGatewayActionTypes =
  GoToMediaGatewayListAction |
  SetMediaGatewayLoadingAction |
  GetMediaGatewayListAction |
  GetMediaGatewayListPendingAction |
  GetMediaGatewayListFulfilledAction |
  GetMediaGatewayAction |
  GetMediaGatewayPendingAction |
  GetMediaGatewayFulfilledAction |
  CreateMediaGatewayAction |
  CreateMediaGatewayPendingAction |
  CreateMediaGatewayFulfilledAction |
  CreateMediaGatewayRejectedAction |
  UpdateMediaGatewayAction |
  UpdateMediaGatewayFulfilledAction |
  UpdateMediaGatewayRejectedAction |
  DeleteMediaGatewayAction |
  DeleteMediaGatewayFulfilledAction |
  DeleteMediaGatewayRejectedAction |
  SelectMediaGatewayAction;
